import client from './client';

export default {
  create(type, id, cb) {
    const req = client.request('post', '/subscriptions', true);
    const body = {
      subscription: {
        subscribable_type: type,
        subscribable_id: id,
      },
    };

    req
      .send(body)
      .end(cb);
  },
};



// WEBPACK FOOTER //
// ./src/lib/subscription.js